module.exports = __webpack_public_path__ + "c10df9e0c35a33acfff43a8715f3ef0a.svg";